import React, { useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
} from "@mui/material";
import api from "../../api/api";

const AddFAQ = () => {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async () => {
    if (!question.trim() || !answer.trim()) return;

    try {
      const payload = { question, answer };
      const response = await api.AddFAQ(payload); // POST API
      if (response.status === 200 || response.status === 201) {
        setSuccessMessage("FAQ added successfully!");
        setQuestion("");
        setAnswer("");
      } else {
        console.warn("Failed to add FAQ:", response);
      }
    } catch (err) {
      console.error("Add FAQ Error:", err);
    }
    finally{
     
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Typography variant="h5" gutterBottom>
        Add New FAQ (Admin)
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          label="Question"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          fullWidth
        />
        <TextField
          label="Answer"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          fullWidth
          multiline
          rows={3}
        />
        <Button variant="contained" onClick={handleSubmit}>
          Add FAQ
        </Button>

        {successMessage && (
          <Typography color="success.main">{successMessage}</Typography>
        )}
      </Box>
    </Container>
  );
};

export default AddFAQ;
